import { Component } from "inferno";
import { T } from "inferno-i18next-dess";
import {
  Community,
  CommunityReportView,
  MyUserInfo,
  ResolveCommunityReport,
} from "lemmy-js-client";
import { mdToHtml } from "@utils/markdown";
import { I18NextService } from "../../services";
import { PersonListing } from "../person/person-listing";
import { tippyMixin } from "../mixins/tippy-mixin";
import { CommunityHeader } from "./community-header";
import ActionButton from "@components/common/content-actions/action-button";

interface Props {
  report: CommunityReportView;
  myUserInfo: MyUserInfo | undefined;
  loading: boolean;
  onResolveReport: (form: ResolveCommunityReport) => void;
}

const reportElements = [
  "name",
  "title",
  "summary",
  "sidebar",
  "icon",
  "banner",
] as const;

@tippyMixin
export class CommunityReport extends Component<Props, object> {
  render() {
    const r = this.props.report;
    const cr = r.community_report;
    const tippyContent = I18NextService.i18n.t(
      r.community_report.resolved ? "unresolve_report" : "resolve_report",
    );

    const mergedCommunity: Community = { ...r.community };
    reportElements.forEach(key => {
      mergedCommunity[key] =
        r.community_report[`original_community_${key}`] ?? "";
    });

    return (
      <div className="community-report">
        <CommunityHeader
          community={mergedCommunity}
          urlCommunityName={r.community.name}
          myUserInfo={this.props.myUserInfo}
        />
        {mergedCommunity.summary && <div>{mergedCommunity.summary}</div>}
        {mergedCommunity.sidebar && (
          <div
            className="md-div"
            dangerouslySetInnerHTML={mdToHtml(mergedCommunity.sidebar, () =>
              this.forceUpdate(),
            )}
          />
        )}
        <div className="aimoo-report-meta">
          <div className="aimoo-report-meta__row">
            <span className="aimoo-report-meta__label">
              {I18NextService.i18n.t("reporter")}
            </span>
            <PersonListing
              person={r.creator}
              banned={false}
              myUserInfo={this.props.myUserInfo}
              muted={false}
            />
          </div>
          <div className="aimoo-report-meta__row aimoo-report-meta__row--reason">
            <span className="aimoo-report-meta__label">
              {I18NextService.i18n.t("reason")}
            </span>
            <span className="aimoo-report-meta__reason">{cr.reason}</span>
          </div>
          {r.resolver && (
            <div className="aimoo-report-meta__row">
              {cr.resolved ? (
                <T i18nKey="resolved_by">
                  #
                  <PersonListing
                    person={r.resolver}
                    banned={false}
                    myUserInfo={this.props.myUserInfo}
                    muted={false}
                  />
                </T>
              ) : (
                <T i18nKey="unresolved_by">
                  #
                  <PersonListing
                    person={r.resolver}
                    banned={false}
                    myUserInfo={this.props.myUserInfo}
                    muted={false}
                  />
                </T>
              )}
            </div>
          )}
        </div>
        <div className="mt-2 aimoo-report-actions">
          <ActionButton
            label={tippyContent}
            icon={r.community_report.resolved ? "check" : "x"}
            loading={this.props.loading}
            inlineWithText
            onClick={() => handleResolveReport(this)}
            iconClass={`text-${r.community_report.resolved ? "success" : "danger"}`}
          />
        </div>
      </div>
    );
  }
}

function handleResolveReport(i: CommunityReport) {
  const cr = i.props.report.community_report;
  i.props.onResolveReport({
    report_id: cr.id,
    resolved: !cr.resolved,
  });
}
